import { t } from "i18next";
import { TicketStatusEnum } from "../services/callCenterService";
import { Country, CustomerGroup } from "../types/enumsNotice";
import { StatusIntent } from "../types/orderIntent";

export const getDescriptionStatusIntent = (status: StatusIntent): string => {
    switch (status) {
        case StatusIntent.AnalisysUnipar:
            return 'Análise Unipar';
        case StatusIntent.PendingCustomer:
            return 'Pendente Cliente';
        default:
            return 'Análise Unipar'
    }

}

export const getDescriptionStatusIntentLanguage = (status: StatusIntent, language: string): string => {
    if(language == 'pt')
    {
        switch (status) {
            case StatusIntent.AnalisysUnipar:
                return 'Análise Unipar';
            case StatusIntent.PendingCustomer:
                return 'Pendente Cliente';
            default:
                return 'Análise Unipar'
        }
    }
    else if(language == 'es')
    {
        switch (status) {
            case StatusIntent.AnalisysUnipar:
                return 'Análisis Unipar';
            case StatusIntent.PendingCustomer:
                return 'Cliente en espera';
            default:
                return 'Análisis Unipar'
        }
    }
    else
    {
        switch (status) {
            case StatusIntent.AnalisysUnipar:
                return 'Unipar Analysis';
            case StatusIntent.PendingCustomer:
                return 'Pending Customer';
            default:
                return 'Unipar Analysis'
        }
    }
}

export const callCenterStatusStyle = [        
    {
        name: TicketStatusEnum.Pending,
        bgColor: '#FFF6C7',
        color: '#DFBC07',
    },
    {
        name: TicketStatusEnum.Served,
        color: '#2C99F7',
        bgColor: '#ECF6FF',
    },
    {
        name: TicketStatusEnum.Finished,
        bgColor: '#EEFFF2',
        color: '#30C10C',
    }
];

export const getTicketDescriptionStatus = (status: TicketStatusEnum) => {
    return t('callCenter.' + TicketStatusEnum[status]?.toLowerCase());
}  

export function getEnumCustomerGroup(id: number): string {
    return CustomerGroup?.[id] ?? '';
}

export function getEnumCountry(id: string): string {
    switch (id) {
        case `BR`:
            return 'Brasil';
        case `AR`:
            return 'Argentina';
        default:
            return 'Todos'
    }
}